import { selectEntityStatus } from "../ui/ui.selectors";
import { GENERATOR_FILTERS } from "./generator-filters.reducer";

export const selectGeneratorFilters = (state) => state[GENERATOR_FILTERS];
export const selectGeneratorFiltersStatus = (state) => selectEntityStatus(state, GENERATOR_FILTERS);
